<script setup lang="ts">
const { close, isOpen } = useAboutModal()

const { data: about } = await useAsyncData('component-about', () =>
  queryCollection('componentAbout').first(),
)
</script>

<template>
  <UModal
    v-model:open="isOpen"
    :ui="{
      overlay: 'sfg-about-overlay',
      content: 'rotate-[-0.6deg]',
    }"
  >
    <template #content>
      <div class="bg-brand-ink text-brand-chalk rounded-card overflow-hidden">
        <div v-if="about" class="flex flex-col items-center gap-6 p-8 sm:p-10 text-center">
          <SfgFlame
            :size="96"
            :disk="false"
            body-color="red"
            flame-color="yellow"
            :tilt="2"
          />

          <h2 class="font-editorial italic font-black text-[32px] leading-none">
            {{ about.heading }}
          </h2>

          <div class="flex flex-col gap-4 max-w-md">
            <p
              v-for="(paragraph, i) in about.body"
              :key="i"
              class="font-body text-body leading-relaxed"
            >
              {{ paragraph }}
            </p>
          </div>

          <p class="font-display uppercase text-[10px] tracking-[0.18em] opacity-60">
            {{ about.footerNote }}
          </p>

          <SfgButton
            variant="primary"
            size="sm"
            @click="close"
          >
            Close
          </SfgButton>
        </div>
      </div>
    </template>
  </UModal>
</template>
